import { render } from "./InputBtn.vue?vue&type=template&id=3c471b6c&scoped=true"
import script from "./InputBtn.vue?vue&type=script&lang=js"
export * from "./InputBtn.vue?vue&type=script&lang=js"

import "./InputBtn.vue?vue&type=style&index=0&id=3c471b6c&scoped=true&lang=css"

import exportComponent from "D:\\code\\m_pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c471b6c"]])

export default __exports__